import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  alert: {
    backgroundColor: theme.palette.background.snackbar,
  },
}))
